import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U2102, { U2102ROLES } from "./U2102";
import U2102RoleList from "./components/U2102RoleList";
import U2102RoleForm from "./components/U2102RoleForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U2102Routes: RouteObject[] = [
  {
    path: "U2102",
    element: <U2000RequireRole allowedRoles={[U2102ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U2102 />,
        children: [
          { index: true, element: <U2102RoleList /> },
          { path: ":id", element: <U2102RoleForm /> },
        ],
      },
    ],
  },
];

export default U2102Routes;
